import Box from "@mui/material/Box";
import Navbar from "../../PreActivation/components/Navbar";

const AiCompetitorsHeader = ({ compact = false, sx = {} }) => (
  <Box sx={sx}>
    <Navbar compact={compact} />
  </Box>
);

export default AiCompetitorsHeader;
